import React, { useEffect, useMemo, useState } from "react";
import { getFirstLetterOfName } from "../Utils";
import { useTranslation } from "react-i18next";

export const DefaultUserDropdown = ({
  loading,
  list,
  duplicateList,
  taskId,
  onChange,
}) => {
  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  // const [userList, setUserList] = useState([]);

  const handleSearchAssigne = (e) => {
    setSearch(e.target.value);
    // if (e.target.value.length > 0) {
    //   const searchedData = duplicateList.filter((option) =>
    //     option.fullName?.toLowerCase().includes(e.target.value.toLowerCase())
    //   );
    //   setUserList(searchedData);
    // } else {
    //   setUserList(duplicateList);
    // }
  };

  const userList = useMemo(() => {
    if (search && search.length > 0) {
      return duplicateList.filter((option) =>
        option.fullName?.toLowerCase().includes(search.toLowerCase())
      );
    }
    return duplicateList;
  }, [search, duplicateList]);

  const handleChangeUser = (e, userId) => {
    const updatedDuplicateAssigneeList = duplicateList.map((assignee) => {
      if (assignee.gid === userId) {
        return { ...assignee, check: e.target.checked, taskId };
      }
      return { ...assignee, taskId };
    });
    // const updatedAssigneeList = userList.map((assignee) => {
    //   if (assignee.gid === userId) {
    //     return { ...assignee, check: e.target.checked, taskId };
    //   }
    //   return { ...assignee, taskId };
    // });

    // State Update
    // setSearch("");
    // setUserList(updatedAssigneeList);

    // Send to Parent Component
    onChange(updatedDuplicateAssigneeList, taskId);
  };

  // useEffect(() => {
  //   setUserList(list);
  // }, [list]);

  return (
    <>
      <li>
        <div className="search-div mb-2">
          <div className="input-group">
            <button type="button" className="input-group-text">
              <i className="pluto-search"></i>
            </button>
            <input
              type="search"
              className="form-control"
              placeholder={t("common.placeHolder.searchAssignee")}
              value={search}
              onChange={handleSearchAssigne}
            />
          </div>
        </div>
      </li>
      <li className="assignee-list-date">
        <ul>
          {loading ? (
            <li className="assignee-item">Loading...</li>
          ) : (
            userList &&
            userList.length > 0 &&
            userList.map((user, index) => (
              <li className="assignee-item" key={index.toString()}>
                <div className="form-check form-check-flex">
                  <div className="assignee-user">
                    {user.photoURL ? (
                      <img
                        src={user.photoURL}
                        alt={`${user.firstName}${user.lastName}`}
                      />
                    ) : (
                      getFirstLetterOfName(user)
                    )}
                  </div>
                  <div className="assignee-name">
                    <p>
                      {user.firstName} {user.lastName}
                    </p>
                  </div>

                  <input
                    type="checkbox"
                    className="form-check-input ms-auto"
                    checked={user.check}
                    // onChange={(e) => onChange(e, user.email, taskId)}
                    onChange={(e) => handleChangeUser(e, user.gid)}
                  />
                </div>
              </li>
            ))
          )}
        </ul>
      </li>
    </>
  );
};
